import { authHeaders } from './auth';

export class ApiError extends Error {
  constructor(public status: number, message: string, public data?: unknown) { super(message); }
}

/** Chama a API do Convés. Os erros de regra (409, 400) voltam com a mensagem pronta para mostrar. */
export async function api<T = unknown>(path: string, opts: { method?: string; body?: unknown } = {}): Promise<T> {
  const res = await fetch('/api/' + path.replace(/^\//, ''), {
    method: opts.method ?? (opts.body === undefined ? 'GET' : 'POST'),
    headers: { ...(await authHeaders()), ...(opts.body === undefined ? {} : { 'Content-Type': 'application/json' }) },
    body: opts.body === undefined ? undefined : JSON.stringify(opts.body),
  });
  if (!res.ok) {
    let msg = 'Não foi possível concluir. Tente de novo.';
    let data: unknown;
    try { const j = await res.json(); msg = j.message ?? msg; data = j.data; } catch { /* sem corpo */ }
    throw new ApiError(res.status, msg, data);
  }
  return (res.status === 204 ? undefined : await res.json()) as T;
}

export const get = <T>(path: string) => api<T>(path);
export const post = <T>(path: string, body: unknown = {}) => api<T>(path, { method: 'POST', body });
export const patch = <T>(path: string, body: unknown) => api<T>(path, { method: 'PATCH', body });
export const put = <T>(path: string, body: unknown) => api<T>(path, { method: 'PUT', body });
export const del = <T>(path: string) => api<T>(path, { method: 'DELETE' });
